import { navigate } from 'gatsby';
import { call, select, put } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { setBannerAPIRequestState } from '../../../effects/message';

export default function* addIntegration(action) {
  try {
    const { AUTH_SERVER_URL } = yield select((state) => state.application.env);
    const { token } = yield select((state) => state.application);
    const { uuid, mediaBillingId } = yield select(
      (state) => state.organization,
    );
    const url = `${AUTH_SERVER_URL}/integrations?integration=${action.payload.id}`;

    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.POST,
      body: {
        token,
        billingId: mediaBillingId,
        organizationUuid: uuid,
      },
    });

    if (!error && success) {
      yield call(navigate, result.authorize_url);
    } else {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage:
            'Something went wrong when trying to add your integration...',
        }),
      );
    }
  } catch (error) {
    console.error(error);
  }
}
